// extracted by mini-css-extract-plugin
module.exports = {"desktop":"1280px"};